<template lang="pug">
BaseButton(
    size="SMALL"
    color="GRAY"
    buttonStyle="OUTLINE"
    @click.native="toggleFacet"
    class="xs:justify-between"
    :class="[ isDisabled ? 'opacity-25 cursor-default' : 'cursor-pointer' ]"
)
    span(class="lg:text-sm") {{ sameDayShippingText }}

    div(
        class="flex-none ml-2 h-4 w-6 lg:w-8 flex items-center rounded-full border-2 border-transparent"
        :class="toggleColors"
    )
        span(
            class="h-3 w-3 bg-white rounded-full transform shadow"
            :class="[ !isActive ? 'translate-x-0' : 'translate-x-4' ]"
        )
</template>

<script>
import BaseButton from '@/components/baseButton'
import SameDayShippingMixin from './mixin'

export default {
    name: 'SameDayShippingButton',
    components: {
        BaseButton,
    },
    mixins: [SameDayShippingMixin],
}
</script>
